import { Button } from '@creditornot/cb-button';
import { ModalContent, ModalFooter } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

type AskLaterModalContentProps = {
  onConfirm: () => void;
};

const ActionsFooter = styled(ModalFooter)`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const AskLaterModalContent = ({ onConfirm }: AskLaterModalContentProps) => {
  return (
    <>
      <ModalContent>
        <Typography.Body2>
          <FormattedMessage id="nps.alerts.ask-later" />
        </Typography.Body2>
      </ModalContent>
      <ActionsFooter>
        <Button variant="primary" size="small" onClick={() => onConfirm()}>
          <FormattedMessage id="nps.alerts.ok" />
        </Button>
      </ActionsFooter>
    </>
  );
};

export default AskLaterModalContent;
